import {
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
  WhatsappIcon,
} from "../SocialIcons";
import { getShareMessageForChannel } from "@qoohoo/common/helpers/channel";
import * as Track from "@qoohoo/common/utils/analytics/track";
import { button, link, pageview } from "@qoohoo/common/constants/analytics";
import CopyLink from "../CopyLink";
import { sendShareEventViaPixel } from "@qoohoo/common/utils/analytics/pixel";
import {
  getWhatsappShareUrl,
  prepareShareObject,
} from "@qoohoo/common/utils/social-share";

const ShareChannel = ({ currentUsername, channelDetails }) => {
  const current_screen = pageview.channel_details;
  const modal_name = "share_channel";

  const [message, url] = getShareMessageForChannel(
    currentUsername,
    channelDetails
  );

  const shareObject = prepareShareObject(url, message);
  const shortEncodedUrl = shareObject.encodedUrl;
  const nonUrlShareableEncodedUrl = shareObject.encodedText;
  const whatsappShareUrl = getWhatsappShareUrl({
    text: shareObject.encodedTextWithUrl,
  });

  function sendSharePixelEventOnClick(medium) {
    sendShareEventViaPixel({
      ...channelDetails,
      currentUsername,
      share_via: medium,
    });
  }

  return (
    <section className="flex flex-col items-center w-full px-5 py-6 border border-dashed rounded-xl border-[#414B53]">
      <div className="mb-6 font-medium">Share the channel</div>
      <CopyLink url={url} message={message} modalName="share_the_channel" />
      <div className="mt-3 mb-4 text-xs text-center">or</div>
      <div className="flex flex-wrap items-center space-x-4">
        <a
          href={whatsappShareUrl}
          target="_blank"
          className="fill-[#E8E8E8] hover:fill-[#25D366] outline-none"
          onClick={() => {
            sendSharePixelEventOnClick("whatsapp");
            Track.linkClick(link.share_via_whatsapp, {
              url: whatsappShareUrl,
              current_screen,
              modal_name,
            });
          }}
        >
          <WhatsappIcon />
        </a>
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${shortEncodedUrl}&quote=${nonUrlShareableEncodedUrl}`}
          target="_blank"
          className="fill-[#E8E8E8] hover:fill-[#1877F2] outline-none"
          onClick={() => {
            sendSharePixelEventOnClick("facebook");
            Track.linkClick(link.share_via_facebook, {
              url: `https://www.facebook.com/sharer/sharer.php?u=${shortEncodedUrl}&quote=${nonUrlShareableEncodedUrl}`,
              current_screen,
              modal_name,
            });
          }}
        >
          <FacebookIcon />
        </a>
        <a
          href={`https://twitter.com/intent/tweet?text=${nonUrlShareableEncodedUrl}&url=${shortEncodedUrl}`}
          target="_blank"
          className="fill-[#E8E8E8] hover:fill-[#1DA1F2] outline-none"
          onClick={() => {
            sendSharePixelEventOnClick("twitter");
            Track.linkClick(link.share_via_twitter, {
              url: `https://twitter.com/intent/tweet?text=${nonUrlShareableEncodedUrl}&url=${shortEncodedUrl}`,
              current_screen,
              modal_name,
            });
          }}
        >
          <TwitterIcon />
        </a>
        <a
          // TODO: Add linkedin api for sharing
          href={`https://www.linkedin.com/shareArticle?mini=true&url=${shortEncodedUrl}&title=${nonUrlShareableEncodedUrl}`}
          target="_blank"
          className="fill-[#E8E8E8] hover:fill-[#00A0DC] outline-none"
          onClick={() => {
            sendSharePixelEventOnClick("linkedin");
            Track.linkClick(link.share_via_linkedin, {
              url: `https://www.linkedin.com/shareArticle?mini=true&url=${shortEncodedUrl}&title=${nonUrlShareableEncodedUrl}`,
              current_screen,
              modal_name,
            });
          }}
        >
          <LinkedinIcon />
        </a>
      </div>
    </section>
  );
};

export default ShareChannel;
